import { CombinedState, createSelector } from '@reduxjs/toolkit';
import { RootStateType } from 'App/store';
import { InterfaceNuvemEnvioOrdersSchema } from '../ordersSlice';
import { StatusType } from '../types';

const isIdle = (status: StatusType) => status === StatusType.Idle;
const isLoading = (status: StatusType) => status === StatusType.Loading;
const isError = (status: StatusType) => status === StatusType.Error;
const isSuccess = (status: StatusType) => status === StatusType.Success;

export const getNuvemEnvioOrdersState = (
  state: RootStateType,
): CombinedState<InterfaceNuvemEnvioOrdersSchema> => state.nuvemEnvioOrders;

export const getNuvemEnvioLabelsData = createSelector(
  getNuvemEnvioOrdersState,
  ({ createNuvemEnvioLabels }) => createNuvemEnvioLabels.data,
);

export const getShowPrintLabelModal = createSelector(
  getNuvemEnvioOrdersState,
  ({ showNuvemEnvioPrintLabelModal }) => showNuvemEnvioPrintLabelModal,
);

export const getNuvemEnvioLabelsStatus = createSelector(
  getNuvemEnvioOrdersState,
  ({ createNuvemEnvioLabels }) => ({
    isIdle: isIdle(createNuvemEnvioLabels.status),
    isLoading: isLoading(createNuvemEnvioLabels.status),
    isError: isError(createNuvemEnvioLabels.status),
    isSuccess: isSuccess(createNuvemEnvioLabels.status),
  }),
);

export const getNuvemEnvioSimulateLabelsData = createSelector(
  getNuvemEnvioOrdersState,
  ({ simulateNuvemEnvioLabels }) => simulateNuvemEnvioLabels.data,
);

export const getNuvemEnvioSimulateLabelsStatus = createSelector(
  getNuvemEnvioOrdersState,
  ({ simulateNuvemEnvioLabels }) => ({
    isIdle: isIdle(simulateNuvemEnvioLabels.status),
    isLoading: isLoading(simulateNuvemEnvioLabels.status),
    isError: isError(simulateNuvemEnvioLabels.status),
    isSuccess: isSuccess(simulateNuvemEnvioLabels.status),
  }),
);

export const getNuvemEnvioCreditRechargeLabelsData = createSelector(
  getNuvemEnvioOrdersState,
  ({ creditRechargeNuvemEnvioLabels }) => creditRechargeNuvemEnvioLabels.data,
);

export const getNuvemEnvioCreditRechargeLabelsStatus = createSelector(
  getNuvemEnvioOrdersState,
  ({ creditRechargeNuvemEnvioLabels }) => ({
    isIdle: isIdle(creditRechargeNuvemEnvioLabels.status),
    isLoading: isLoading(creditRechargeNuvemEnvioLabels.status),
    isError: isError(creditRechargeNuvemEnvioLabels.status),
    isSuccess: isSuccess(creditRechargeNuvemEnvioLabels.status),
  }),
);

export const getNuvemEnvioAsyncLabelsData = createSelector(
  getNuvemEnvioOrdersState,
  ({ createNuvemEnvioAsyncLabels }) => createNuvemEnvioAsyncLabels.data,
);

export const getNuvemEnvioAsyncLabelsStatus = createSelector(
  getNuvemEnvioOrdersState,
  ({ createNuvemEnvioAsyncLabels }) => ({
    isIdle: isIdle(createNuvemEnvioAsyncLabels.status),
    isLoading: isLoading(createNuvemEnvioAsyncLabels.status),
    isError: isError(createNuvemEnvioAsyncLabels.status),
    isSuccess: isSuccess(createNuvemEnvioAsyncLabels.status),
  }),
);

export const getNuvemEnvioSearchLabelsData = createSelector(
  getNuvemEnvioOrdersState,
  ({ searchForNuvemEnvioLabels }) => searchForNuvemEnvioLabels.data,
);

export const getNuvemEnvioSearchLabelsStatus = createSelector(
  getNuvemEnvioOrdersState,
  ({ searchForNuvemEnvioLabels }) => ({
    isIdle: isIdle(searchForNuvemEnvioLabels.status),
    isLoading: isLoading(searchForNuvemEnvioLabels.status),
    isError: isError(searchForNuvemEnvioLabels.status),
    isSuccess: isSuccess(searchForNuvemEnvioLabels.status),
  }),
);

export const getNuvemEnvioDownloadLabelsData = createSelector(
  getNuvemEnvioOrdersState,
  ({ downloadNuvemEnvioLabel }) => downloadNuvemEnvioLabel.data,
);

export const getNuvemEnvioDownloadLabelsStatus = createSelector(
  getNuvemEnvioOrdersState,
  ({ downloadNuvemEnvioLabel }) => ({
    isIdle: isIdle(downloadNuvemEnvioLabel.status),
    isLoading: isLoading(downloadNuvemEnvioLabel.status),
    isError: isError(downloadNuvemEnvioLabel.status),
    isSuccess: isSuccess(downloadNuvemEnvioLabel.status),
  }),
);
